import SelectComponent from 'react-select';

interface SelectProps {
  options: { value: string, label: string }[];
  value?: string;
  onChange?: (value: any) => void;
}

export function Select({ options, value, onChange }: SelectProps) {
  const innerValue = options.find(option => option.value === value);

  return (
    <SelectComponent
      classNames={{
        control: () => 'select',
        indicatorSeparator: () => 'bg-secondary!',
        singleValue: () => 'text-white!',
        menu: () => 'select-menu',
        option: (state) => {
          return state.isSelected
            ? 'option-active active cursor-pointer!'
            : 'bg-transparent! cursor-pointer!';
        },
      }}
      onChange={({ value }: any) => onChange?.(value)}
      isSearchable={false}
      value={innerValue}
      options={options}
    />
  );
}